import { errorViolatesForeignKeyManager } from '@/services/validation/validation';

export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      errorViolatesForeignKeyManager(message, messages);
    }
  });
}
